export { AboutCardPrimary, Image, Content } from './AboutCardPrimary';
